import { Link, useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import './academy.css'
import React, { useEffect, useState, useRef } from 'react';
import { Tooltip } from 'react-tooltip'
import { useHistory } from 'react-router-dom';
import ModalQuiz from './ModalQuiz';
import ModuleExcercise from './ModuleExcercise';

const Module = (props) => {
    const bgImage = "url('/assets/images/BgImage.jpg')";
    const backIcon = "/assets/images/icons8-back-64.png";
    const exerciseIcon = "/assets/images/chapter-exercise-01-48.png";
    const quizIcon = "/assets/images/classroom-quiz-48.png";
    const thumbnail = "/assets/images/";
    const checkIcon = "/assets/images/check-mark.png";
    const [isModalOpen, setModalOpen] = useState(false);
    const [isModalExcerciseOpen, setModalExcerciseOpen] = useState(false);
    const moduleId = useParams();
    const [moduleData, setModuleData] = useState([]);
    const [currentId, setCurrentId] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [modules, setModules] = useState([]);
    const [testResults, setResults] = useState(null);
    const [allowedQuiz, setAllowedQuiz] = useState(false);
    const [allowedExcercise, setAllowedExcercise] = useState(false);
    const [excerciseComplete, setExcerciseComplete] = useState(false);
    const [completedQuiz, setCompleteQuiz] = useState(false);
    let history = useHistory();
    function handleClick(module) {
        if (!module.disabled) {
            history.push(`/module/${module.moduleId}`);
        }
    }
    const getQuizLog = async () => {
        const response = await fetch(`/api/Course/GetQuizLog/${moduleId.id}`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        setCompleteQuiz(result.isComplete);
    }
    const getModuleContent = () => {
        var pId = localStorage.getItem('MT_ID');
        fetch(`/api/Course/GetModule/${moduleId.id}/${pId}`)
            .then(response => response.json())
            .then(data => {
                setModuleData(data)
            })
    }
    useEffect(() => {
        // Get the id from route parameters
        var pId = localStorage.getItem('MT_ID');
        const idFromRoute = props.match.params.id;
        setCurrentId(idFromRoute)
        fetch(`/api/Course/GetModule/${idFromRoute}/${pId}`)
            .then(response => response.json())
            .then(data => {
                setModuleData(data)
                setPdfUrl(`/api/Course/GetTopicFile/${data[0].fileName}`)
            })
            .catch(error => console.error('Error fetching module data:', error));
        // setCurrentId(idFromRoute);
        var pId = localStorage.getItem('MT_ID');
        fetch(`/api/Course/GetModules/${pId}`)
            .then(response => response.json())
            .then(data => setModules(data))
            .catch(error => console.error('Error fetching data:', error));
    }, []);
    const prevModuleId = useRef();
    useEffect(() => {
        if (moduleId && moduleId.id && moduleId.id !== prevModuleId.current) {
            var userID = localStorage.getItem('MT_ID');
            if (!userID) {
                window.location.href = '/';
            }
            prevModuleId.current = moduleId.id;
            setCurrentId(moduleId.id);
            var pId = localStorage.getItem('MT_ID');
            // Assuming the API endpoint to fetch a specific module looks like /api/Course/GetModule/{id}
            fetch(`/api/Course/GetModule/${moduleId.id}/${pId}`)
                .then(response => response.json())
                .then(data => {
                    setModuleData(data)
                    setPdfUrl(`/api/Course/GetTopicFile/${data[0].fileName}`)
                    setTimeout(() => {
                        submitLogs(data[0].contentId, true, moduleId.id);
                        getQuizLog();
                    }, 100);
                })
                .catch(error => console.error('Error fetching module data:', error));
            fetch(`/api/Course/GetQuizResult/${moduleId.id}/${userID}`)
                .then(response2 => response2.json())
                .then(data1 => {
                    if (data1.highestMarks != 0 && data1.total != 0) {
                        setResults(data1);
                    }
                    else {
                        setResults(null);
                    }
                })
                .catch(error => console.error('Error fetching module data:', error));
            fetch(`/api/Course/GetQuestions/${moduleId.id}`)
                .then(response3 => response3.json())
                .then(data2 => {
                    if (data2.length > 0) {
                        setAllowedQuiz(true);
                    }
                    else {
                        setAllowedQuiz(false);
                    }
                })
                .catch(error => console.error('Error fetching module data:', error));
            var PID = localStorage.getItem('MT_ID');
            fetch(`/api/Course/GetExcercises/${moduleId.id}/${PID}`)
                .then(response4 => response4.json())
                .then(data3 => {
                    if (data3.length > 0) {
                        setAllowedExcercise(true);
                    }
                    else {
                        setAllowedExcercise(false);
                    }
                })
                .catch(error => console.error('Error fetching module Exzcercise data:', error));
            var PID = localStorage.getItem('MT_ID');
            fetch(`/api/Course/GetExcerciseComplete/${moduleId.id}/${PID}`)
                .then(response5 => response5.json())
                .then(data4 => {
                    if (data4) {
                        setExcerciseComplete(true);
                    }
                    else {
                        setExcerciseComplete(false);
                    }
                })
                .catch(error => console.error('Error fetching module Exzcercise data:', error));
        }
    }, [moduleId]);
    const submitLogs = async (topicId, isTopic, moduleId) => {
        var url = `/api/Course/SubmitLog`
        // Define the parameters you want to pass in the body
        var parameters = {
            topicId: topicId,
            isModuleTopic: isTopic,
            moduleId: moduleId,
            p_ID: localStorage.getItem('MT_ID')
            // ... add more parameters as needed
        };
        var body = JSON.stringify(parameters);
        await fetch(url, {
            method: 'POST', // or 'PUT' if you are updating data
            headers: {
                'Content-Type': 'application/json'
                // Add any other headers you need here
            },
            body: body
        }).then(response => response.json())
            .then(d => {
                getModuleContent();
                console.log('sadfasdf');
            })

    }

    const handleTopicClick = (topicId, contentId) => {
        setPdfUrl(`/api/Course/GetTopicFile/${topicId}`);
        submitLogs(contentId, true, currentId)
    }

    return (
        <div className="bgStyle" style={{ backgroundImage: bgImage }}>
            <h1 className='titleStyle mb-4 mt-4'>{moduleData.length > 0 ? moduleData[0].moduleName : ''}</h1>
            <Link to={`/academy`}>
                <img src={backIcon} alt="" width='50' height='50' style={{ position: 'fixed', top: '30px', left: '30px' }} />
            </Link>
            <Tooltip id="my-tooltip" className="react-tooltip" place="top" type="dark" effect="solid" />

            <div className="moduleContent  mt-3 row  ml-3 mr-3" style={{ marginLeft: '1rem', marginRight: '1rem' }} >
                <div className="mediaPlayer pr-2 col-md-8" >
                    <div className='row'>
                        <div className='col-md-2 text-center ' style={{ fontSize: '17px', fontWeight: '800' }}>
                            {modules.map(module => (
                                module.disabled == true ? <div data-tooltip-id="my-tooltip" data-tooltip-content="Module Locked: Complete Previous Module & Wait for Previous Month's Duration" style={{ border: '2px solid grey', }} className='marginTopModules p-2'>
                                    M {module.moduleNumber}
                                </div>
                                    :
                                    currentId == module.moduleId ?
                                        <div onClick={(e) => handleClick(module)} style={{ border: '3px solid Black', cursor: 'pointer' }} className='marginTopModules p-2'>
                                            M {module.moduleNumber}
                                        </div>
                                        :
                                        <div onClick={(e) => handleClick(module)} style={{ border: '2px solid Black', cursor: 'pointer' }} className='marginTopModules p-2'>
                                            M {module.moduleNumber}
                                        </div>
                            ))}

                        </div>

                        <div className='col-md-10'>
                            {pdfUrl ? <iframe src={pdfUrl + '#pagemode=none'} width="100%" height="700px" /> : <></>}
                        </div>
                    </div>
                    {/* Display the PDF */}


                </div>
                <div className="topicsList ml-1 col-md-4" style={{ paddingLeft: '0px', paddingRight: '0px' }} >
                    <h6 className='text-center pt-2 headingStyles pb-2'>List of Content</h6>
                    <div className='topicsListUnder'>
                        {moduleData.length > 0 ? moduleData.map((topic, index) => (
                            <div className='topicContent' key={index} onClick={() => handleTopicClick(topic.fileName, topic.contentId)} style={{ cursor: 'pointer', marginBottom: '10px', position: 'relative' }}>

                                {/* Thumbnail */}
                                <img
                                    src={thumbnail + topic.thumbnail}
                                    alt={`${topic} thumbnail`}
                                    style={{
                                        width: '90px',
                                        height: '63px',
                                        borderRadius: '10px',
                                        marginRight: '10px',
                                        float: 'left'
                                    }}
                                />

                                {/* Topic Title */}
                                <p style={{ padding: '0px', marginBottom: '2px', fontSize: '12px' }}><b>{topic.topicTitle}</b> </p>

                                {/* Topic Description */}
                                <p style={{ fontSize: '12px', fontFamily: 'Roboto' }}>{topic.description}</p>

                                {/* Clear the float */}
                                <div style={{ clear: 'both' }}></div>
                                <div>
                                    {topic.isComplete && <img height='30' width='30' style={{ position: 'absolute', bottom: '5px', right: '8px' }} src={checkIcon} alt="" />}
                                </div>
                            </div>
                        )) : <></>}
                    </div>
                    <div style={{ textAlign: 'center', color: 'green', border: '2px solid black', position: 'relative', fontSize: '18px', backgroundColor: 'white', cursor: 'pointer', position: 'relative' }} className='pt-3 pb-3 mt-2'>Quiz
                        <br />
                        {completedQuiz && <img height='50' width='50' style={{ position: 'absolute', top: '13px', right: '8px' }} src={checkIcon} alt="" />}
                        {allowedQuiz && <img onClick={() => { setModalOpen(true) }} src={quizIcon} alt="" width='50' height='50' />}
                        {!allowedQuiz && <img src={quizIcon} alt="" width='50' height='50' />}
                        {testResults && (
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent overlay
                                color: '#fff',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '20px'
                            }}>
                                Highest Marks :
                                {testResults.highestMarks} / {testResults.total}
                                <button className='start-button-quiz' onClick={() => { setModalOpen(true) }}
                                    style={{
                                        cursor: 'pointer',
                                        position: 'absolute',
                                        bottom: '4px',
                                        fontSize: '16px'
                                    }}>Start Quiz</button>
                            </div>
                        )}
                    </div>
                    <div style={{ position: 'relative', textAlign: 'center', color: 'green', border: '2px solid black', fontSize: '18px', backgroundColor: 'white' }} className='pt-3 pb-3 mt-2'>Exercises
                        <br />
                        {allowedExcercise && <img onClick={() => { setModalExcerciseOpen(true) }} src={exerciseIcon} alt="" width='50' height='50' />}
                        {!allowedExcercise && <img src={exerciseIcon} alt="" width='50' height='50' />}
                        {
                            excerciseComplete &&
                            <div>
                                <img height='30' width='30' style={{ position: 'absolute', bottom: '5px', right: '8px' }} src={checkIcon} alt="" />
                            </div>
                        }
                        {/* <img src={exerciseIcon} alt="" width='50' height='50' /> */}
                    </div>
                    {/* Sample topics - adjust as needed */}

                </div>
                <ModalQuiz id={currentId} isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
                <ModuleExcercise id={currentId} isOpen={isModalExcerciseOpen} onClose={() => setModalExcerciseOpen(false)} />
            </div>
        </div >
    );
}

export default Module;